import axios from 'axios'
const user = {
    state: {
        token: ''
    },

    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        }
    },
    actions: {
        login({ commit }, { api, userinfo }) {
            return new Promise((resolve, reject) => {
                axios.defaults.headers = {
                    "Content-Type": "application/json;charset=utf-8",
                    "token": '12131212'
                }
                axios.post(`${api}/user/login`, {

                    ...userinfo
                }).then(res => {
                    console.log("hhhhh", res);
                    if (res.data.code == 200) {
                        console.log(res.data.data);
                        let token = res.data.data.token
                        commit('SET_TOKEN', token)
                        window.localStorage.setItem('userUuid', res.data.data.userUuid)
                        window.localStorage.setItem('password', userinfo.password)
                        window.localStorage.setItem('islogin', true)
                        window.localStorage.setItem('role', res.data.data.role)
                        window.localStorage.setItem('token', res.data.data.token)
                        axios.defaults.headers['token'] = token
                        // 用的时候直接
                        // window.localStorage.getItem('token')

                        // alert("登陆成功！");
                        resolve()

                    } else if (res.data.code == 400) {
                        alert( res.data.message);
                        reject()
                    }

                })

            })
        }
    }
}

export default user